import { ACTIONS_TYPES } from "../utils/constants";


export function registerUserRequest(payload) {
  return {
    type: ACTIONS_TYPES.REGISTER_USER_REQUEST,
    payload
  }
}

export function registerUserSuccess(response) {
  return {
    type: ACTIONS_TYPES.REGISTER_USER_SUCCESS,
    payload: response,
  }
}

export function registerUserFailed(response) {
  return {
    type: ACTIONS_TYPES.REGISTER_USER_FAILED,
    payload: response,
  }
}

export function registerUserReset() {
  return {
    type: ACTIONS_TYPES.REGISTER_USER_RESET,
  }
}

